import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_BRAZE_AGENTIC_AI } from "@lib/shared_constants";

/**
 * One tool offered by the Braze MCP server, as flattened by BrazeMcpController.
 *
 * `readOnly`, `destructive` and `idempotent` come from the server's own MCP
 * annotations rather than a list maintained here, which is what keeps the
 * client's approval decisions in step with a tool surface it does not own.
 */
export interface BrazeMcpTool {
  name: string;
  description: string;
  /** JSON Schema for the tool's arguments, as published by the MCP server. */
  input_schema: Record<string, unknown>;
  read_only: boolean;
  destructive: boolean;
  idempotent: boolean;
}

export interface GetAppGroupIdBrazeMcpToolsResult {
  tools: BrazeMcpTool[];
}

export type GetAppGroupIdBrazeMcpToolsDisabledError = FetchUserEncodedError<
  SHARED_CONSTANTS_BRAZE_AGENTIC_AI["BRAZE_MCP_ERROR_CODES"]["MCP_DISABLED"]
>;

export type GetAppGroupIdBrazeMcpToolsUnavailableError = FetchUserEncodedError<
  SHARED_CONSTANTS_BRAZE_AGENTIC_AI["BRAZE_MCP_ERROR_CODES"]["MCP_UNAVAILABLE"]
>;

export type GetAppGroupIdBrazeMcpToolsErrors =
  | GetAppGroupIdBrazeMcpToolsDisabledError
  | GetAppGroupIdBrazeMcpToolsUnavailableError;

export const isGetAppGroupIdBrazeMcpToolsError = (
  error: FetchRequestError
): error is GetAppGroupIdBrazeMcpToolsErrors => {
  return error instanceof FetchUserEncodedError;
};
